import React from 'react';
import { NavLink } from "react-router-dom";


const OurServices = () => {
  return (
    <div>
    <section className="bg-white">
      {/* Background banner with heading */}
          <div
              className="relative w-full h-96 bg-cover bg-center bg-fixed"
              style={{ backgroundImage: "url('/images/Services1.jpg')" }}
            >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-white text-3xl font-bold">OUR SERVICES</h1>
      </div>
    </div>

      {/* Content Section */}
      <div className="container mx-auto px-6 lg:px-20 py-12 flex flex-col lg:flex-row items-center gap-12 lg:mr-14">
        {/* Left - Text */}
        <div className="lg:w-1/3">
          <h3 className="text-base font-bold uppercase text-[#75441f] text-Inter mb-4">Abha Care Disability Services</h3>
          <p className="text-gray-700 text-base text-Inter leading-relaxed">
            We want to create a community of well-rounded, well-adjusted and empowered individuals with disabilities and professional
            carers who work together to reach common goals. We aspire to be progressive and proactive, focusing on achieving positive
            outcomes for our participants.
          </p>
        </div>

        {/* Right - Image */}
        <div className="lg:w-1/3">
          <img
            src="/images/Services2.jpg"
            alt="Care service"
            className="rounded-lg shadow-md w-full object-cover"
          />
        </div>
      </div>
    </section>

    {/*Assistance*/}
<section className="bg-[#5B7E57] py-16">
  <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-10 bg-[#efedf3] p-5">
    
    {/* Card 1 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services3.jpg" alt="Assistance with Personal Tasks" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">ASSISTANCE WITH DAILY PERSONAL TASKS</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        We provide support for minor housekeeping tasks such as cleaning, meal preparation, and mealtime assistance.
      </p>
      <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>

    {/* Card 2 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services4.jpg" alt="Personal Care Support" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">PERSONAL CARE SUPPORT</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        NDIS participants can benefit from individual care support including bathing, dressing, grooming, and more.
      </p>
      <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>

    {/* Card 3 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services5.jpg" alt="Transport and Travel Assistance" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">TRANSPORT AND TRAVEL ASSISTANCE</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        With our assistance, you can attend medical appointments, community engagements, or social events on time.
      </p>
      <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>

    {/* Card 4 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services6.jpg" alt="Community Participation" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">AID IN COMMUNITY PARTICIPATION</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        We encourage engagement to help participants pursue their interests and build meaningful connections.
      </p>
      <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>
 {/* Card 5 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services7.jpg" alt="Community Participation" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">Daily Tasks/Shared Living Services</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        Enjoy living in a safe and supportive environment. ABHA Care can help you with your daily tasks and shared living arrangements.
      </p>
     <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>

     {/* Card 6 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services8.jpg" alt="Community Participation" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">Respite Care:</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        We offer flexible short-term care for NDIS participants whose usual family carers are not available or to give our participants a break from the usual home setting, allowing them to try something new.
      </p>
      <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>

     {/* Card 7 */}
    <div className="bg-white p-4 rounded shadow-md">
      <img src="/images/Services9.jpg" alt="Community Participation" className="w-full h-52 object-cover rounded" />
      <h3 className="text-center font-semibold mt-4">Life Skills Development and Training</h3>
      <p className="text-center text-sm mt-2 text-gray-700">
        Life skills are important survival skills. It enables us to function properly and deal with unexpected and unavoidable circumstances. Let ABHA Care equip you with these skills.
      </p>
      <a href="/contact" className="block mx-auto text-[#5B7E57] font-semibold underline cursor-pointer w-fit">Contact Us...</a>
    </div>
  </div>
</section>

 {/*Info Section */}
    <section className="bg-[#3f4f2b] text-white py-40">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10 text-sm">
        {/* Logo + Location */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4">
          <img src="/images/Logo-inverted.svg" alt="ABHA CARE Logo" className="h-16 mx-auto md:mx-0" />
          <p className="font-semibold">New South Wales, Australia</p>
        </div>
    
        {/* Site Links */}
        <div>
          <h4 className="font-bold mb-4 text-lg">Site</h4>
          <ul className="space-y-2 text-lg">
            <li><NavLink to="/" className="hover:underline">Home</NavLink></li>
            <li><NavLink to="/about" className="hover:underline">About Us</NavLink></li>
            <li><NavLink to="/services" className="hover:underline">Services</NavLink></li>
            <li><NavLink to="/faq" className="hover:underline">FAQ</NavLink></li>
            <li><NavLink to="/contact" className="hover:underline">Contact Us</NavLink></li>
          </ul>
        </div>
    
        {/* Location + Hours */}
        <div>
          <h4 className="font-bold mb-4 text-lg">Location</h4>
          <p className="text-lg">Abha Care Pty Ltd<br />
            <br />
           </p>
    
          <h4 className="font-bold mt-6 mb-2 text-lg">Office Hours</h4>
          <p className="text-lg">
                      Monday - Friday: 9:00AM - 5:00PM<br />
                      Saturday & Sunday: Closed</p>
        </div>
    
        {/* Contact Info */}
        <div>
          <h4 className="font-bold mb-4 text-lg">Contact</h4>
          <p className="text-lg">Phone: 02 8395 2893<br /></p>
          <p className="text-lg  ml-14">1300 157 211<br /></p>
          <p className="mt-2 text-lg">
            <a href="mailto:info@abhacare.com.au" className="hover:underline text-lg">
              info@abhacare.com.au
            </a>
          </p>
        </div>
      </div>
    </section>

    </div>
  );
};

export default OurServices;

